<div tabindex="-1">
  <ng-container
    *ngComponentOutlet="params.column.colDef.customEditor; injector: injector">
  </ng-container>
</div>